'use client'

import Link from 'next/link'
import { AckoDriveLogo } from '@components/Ackodrive/common/AckoDriveLogo'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@components/Ackodrive/footer/footerAccordian'
import Image from 'next/image'
import {
  FACEBOOK_ICON,
  INSTAGRAM_ICON,
  TWITTER_ICON,
  YOUTUBE_ICON,
} from '@components/Ackodrive/footer/constants/footerLogos'
import styles from './Footer.module.scss'

const AckoDriveFooter = () => {
  const companyLinks = [
    { name: 'About Us', href: '/about-us/' },
    { name: 'Contact Us', href: '/contact-us/' },
    { name: 'Group company', href: 'https://www.acko.com/' },
  ]

  const legalLinks = [
    { name: 'Privacy Policy', href: '/privacy-policy/' },
    { name: 'Terms and Conditions', href: '/terms-and-conditions/' },
    { name: 'Car Insurance', href: 'https://www.acko.com/car-insurance/' },
    { name: 'Bike Insurance', href: 'https://www.acko.com/two-wheeler-insurance/' },
    { name: 'Travel Insurance', href: 'https://www.acko.com/travel-insurance/' },
    { name: 'Visa', href: 'https://www.acko.com/visa/' },
  ]

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.desktopFooter}>
          <div className={styles.desktopFooterColumn}>
            <Link href="/" className={styles.logoLink}>
              <AckoDriveLogo className={styles.ackoDriveLogo} variant="dark" />
            </Link>
            <p className={styles.addressText}>
              36/5, Hustlehub One East, Somasandrapalya, 27th Main Rd, Sector 2, HSR Layout, Bengaluru, Karnataka
              560102.
            </p>
            <div className={styles.socialLinks}>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <Image src={YOUTUBE_ICON} loading="lazy" alt="YouTube icon" width={32} height={32} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <Image src={INSTAGRAM_ICON} alt="Instagram icon" width={32} height={32} loading="lazy" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <Image src={TWITTER_ICON} alt="Twitter icon" width={32} height={32} loading="lazy" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <Image src={FACEBOOK_ICON} alt="Facebook icon" width={32} height={32} loading="lazy" />
              </a>
            </div>
          </div>

          <div className={styles.desktopFooterDivider} />

          <div className={styles.desktopFooterColumn}>
            <h3 className={styles.companyHeading}>COMPANY</h3>
            <ul className={styles.companyLinksList}>
              {companyLinks.map((link, index) => (
                <li key={index}>
                  <Link href={link.href} className={styles.companyLink}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.desktopFooterDivider} />

          <div className={styles.desktopFooterColumn}>
            <h3 className={styles.legalHeading}>LEGAL</h3>
            <ul className={styles.legalLinksList}>
              {legalLinks.map((link, index) => (
                <li key={index}>
                  <Link href={link.href} className={styles.legalLink}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.mobileFooter}>
          <div className={styles.mobileFooterTop}>
            <div className={styles.logoAddress}>
              <Link href="/" className={styles.logoLink}>
                <AckoDriveLogo className={styles.ackoDriveLogo} variant="dark" />
              </Link>
              <p className={styles.addressText}>
                36/5, Hustlehub One East, Somasandrapalya, 27th Main Rd, Sector 2, HSR Layout, Bengaluru, Karnataka
                560102.
              </p>
            </div>
            <div className={styles.socialLinks}>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <Image src={YOUTUBE_ICON} loading="lazy" alt="YouTube icon" width={24} height={24} priority={false} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <Image
                  src={INSTAGRAM_ICON}
                  loading="lazy"
                  alt="Instagram icon"
                  width={24}
                  height={24}
                  priority={false}
                />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <Image src={TWITTER_ICON} loading="lazy" alt="Twitter icon" width={24} height={24} priority={false} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <Image src={FACEBOOK_ICON} loading="lazy" alt="Facebook icon" width={24} height={24} priority={false} />
              </a>
            </div>
          </div>

          <div className={styles.mobileFooterDivider} />

          <div className={styles.mobileFooterAccordion}>
            <Accordion type="multiple" className={styles.accordion}>
              <AccordionItem value="company" className={styles.accordionItem}>
                <AccordionTrigger value="company" className={styles.accordionTrigger}>
                  COMPANY
                </AccordionTrigger>
                <AccordionContent value="company" className={styles.accordionContent}>
                  <ul className={styles.companyLinksList}>
                    {companyLinks.map((link, index) => (
                      <li key={index}>
                        <Link href={link.href} className={styles.companyLink}>
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="legal" className={styles.accordionItem}>
                <AccordionTrigger value="legal" className={styles.accordionTrigger}>
                  LEGAL
                </AccordionTrigger>
                <AccordionContent value="legal" className={styles.accordionContent}>
                  <ul className={styles.legalLinksList}>
                    {legalLinks.map((link, index) => (
                      <li key={index}>
                        <Link href={link.href} className={styles.legalLink}>
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default AckoDriveFooter
